export default __webpack_public_path__ + "static/media/point-map.4fb929b7.png";